module.exports = __webpack_public_path__ + "fonts/montserrat-v15-latin-500italic.72c01f75.woff";